import React from 'react';
import { Paper, Typography, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { BieMoney } from './BieValue';

type Props = { rows?: any[] };

class MarginBridge extends React.PureComponent<Props> {
  render() {
    const { rows = [] } = this.props;
    return (
      <Paper elevation={1} sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>Margin Bridge</Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Step</TableCell>
              <TableCell align="right">Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r, i) => (
              <TableRow key={`${r.stepcode}-${i}`}>
                <TableCell>{r.stepname}</TableCell>
                <TableCell align="right"><BieMoney value={r.amount} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

export default MarginBridge;
